const TOKEN_KEY = "ds_gateway_token";
const TOKEN_NAME = "satoken";

export function getAuthToken() {
  return localStorage.getItem(TOKEN_KEY) || "";
}

export function setAuthToken(token) {
  if (!token) {
    return;
  }
  localStorage.setItem(TOKEN_KEY, token);
  // Element-UI Upload、window.open 下载不经过 Axios，使用同源 Cookie 携带令牌。
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${TOKEN_NAME}=${encodeURIComponent(token)}; Path=/; SameSite=Lax${secure}`;
}

export function clearAuthToken() {
  localStorage.removeItem(TOKEN_KEY);
  document.cookie = `${TOKEN_NAME}=; Path=/; Max-Age=0; SameSite=Lax`;
}

export function getAuthHeaders() {
  const token = getAuthToken();
  return token ? { [TOKEN_NAME]: token } : {};
}

export { TOKEN_NAME };
